export const noDefaultArchivePolicyText = "SUd";
export const noDefaultDeletePolicyText = "TUd";
export const useParentFolderPolicyText = "UUd";
export default {noDefaultArchivePolicyText,noDefaultDeletePolicyText,useParentFolderPolicyText};